import Header from "../Components/Header";
import "./ContentSettings.css";
import { useEffect, useState } from "react";
import API_BASE from "../config";

const createEmptyBanner = () => ({
  id: 0,
  title: "",
  description: "",
  isActive: true,

  image: null,
  preview: "",

  card: {
    title: "",
    description: "",
    image: null,
    preview: "",
  },
});

const ContentSettings = () => {
  const [showPopup, setShowPopup] = useState(false);

  const [banners, setBanners] = useState([
    createEmptyBanner(),
    createEmptyBanner(),
    createEmptyBanner(),
  ]);

  // LOAD EXISTING BANNERS
  useEffect(() => {
    fetch(`${API_BASE}/HeroBanner/admin`)
      .then((res) => res.json())
      .then((data) => {
        const mapped = data.map((banner) => ({
          id: banner.id,
          title: banner.title || "",
          description: banner.description || "",
          isActive: banner.isActive,

          image: null,
          preview: banner.imageUrl
            ? API_BASE + banner.imageUrl
            : "",

          card: {
            title: banner.cards?.[0]?.title || "",
            description:
              banner.cards?.[0]?.description || "",

            image: null,

            preview: banner.cards?.[0]?.imageUrl
              ? API_BASE +
              banner.cards?.[0]?.imageUrl
              : "",
          },
        }));

        while (mapped.length < 3) {
          mapped.push(createEmptyBanner());
        }

        setBanners(mapped.slice(0, 3));
      });
  }, []);

  // BANNER FIELD CHANGE
  const handleBannerChange = (
    bannerIndex,
    field,
    value
  ) => {
    const updated = [...banners];

    updated[bannerIndex][field] = value;

    setBanners(updated);
  };

  // BANNER IMAGE
  const handleBannerImage = (
    bannerIndex,
    file
  ) => {
    const updated = [...banners];

    updated[bannerIndex].image = file;

    updated[bannerIndex].preview =
      URL.createObjectURL(file);

    setBanners(updated);
  };

  // CARD FIELD CHANGE
  const handleCardChange = (
    bannerIndex,
    field,
    value
  ) => {
    const updated = [...banners];

    updated[bannerIndex].card[field] = value;

    setBanners(updated);
  };

  // CARD IMAGE
  const handleCardImage = (
    bannerIndex,
    file
  ) => {
    const updated = [...banners];

    updated[bannerIndex].card.image = file;

    updated[bannerIndex].card.preview =
      URL.createObjectURL(file);

    setBanners(updated);
  };

  // SAVE SINGLE BANNER
  const saveBanner = async (banner) => {
    const formData = new FormData();

    formData.append("Title", banner.title || "");

    formData.append(
      "Description",
      banner.description || ""
    );

    formData.append(
      "IsActive",
      banner.isActive ? "true" : "false"
    );

    // Banner Image
    if (banner.image) {
      formData.append("Image", banner.image);
    }

    // Card Data
    formData.append(
      "CardTitles",
      banner.card.title || ""
    );

    formData.append(
      "CardDescriptions",
      banner.card.description || ""
    );

    // IMPORTANT
    formData.append(
      "CardImages",
      banner.card.image || new Blob()
    );

    let response;

    // UPDATE
    if (banner.id > 0) {
      response = await fetch(
        `${API_BASE}/HeroBanner/${banner.id}`,
        {
          method: "PUT",
          body: formData,
        }
      );
    }

    // CREATE
    else {
      if (!banner.image) return;

      response = await fetch(
        `${API_BASE}/HeroBanner`,
        {
          method: "POST",
          body: formData,
        }
      );
    }

    if (!response.ok) {
      const errorText = await response.text();

      console.log(errorText);

      throw new Error(errorText);
    }
  };

  // SAVE ALL
  const handleSaveAll = async () => {
    try {
      for (const banner of banners) {
        await saveBanner(banner);
      }

      setShowPopup(true);

      setTimeout(() => {
        setShowPopup(false);
      }, 2000);
    } catch (err) {
      console.error(err);

      alert("Error saving banners");
    }
  };

  return (
    <div className="contentsettings-page">
      <Header />

      {/* HEADER */}
      <div className="contentsettings-header">
        <div>
          <h2>Hero Banner Settings</h2>
          <p>
            Manage homepage hero banners
          </p>
        </div>

        <button
          className="contentsettings-save-btn"
          onClick={handleSaveAll}
        >
          Save Changes
        </button>
      </div>

      {/* BANNERS */}
      {banners.map((banner, bannerIndex) => (
        <div
          className="contentsettings-card"
          key={bannerIndex}
        >
          <div className="contentsettings-banner-top">
            <div>
              <h2>Banner {bannerIndex + 1}</h2>

              <p className="banner-status-text">
                {banner.isActive
                  ? "Active Banner"
                  : "Hidden Banner"}
              </p>
            </div>

            <label className="modern-toggle">
              <input
                type="checkbox"
                checked={banner.isActive}
                onChange={(e) =>
                  handleBannerChange(
                    bannerIndex,
                    "isActive",
                    e.target.checked
                  )
                }
              />

              <span className="modern-slider"></span>
            </label>
          </div>

          {/* TITLE */}
          <p className="contentsettings-section-title">
            Hero Title
          </p>

          <input
            className="contentsettings-input"
            value={banner.title}
            onChange={(e) =>
              handleBannerChange(
                bannerIndex,
                "title",
                e.target.value
              )
            }
          />

          {/* DESCRIPTION */}
          <p className="contentsettings-section-title">
            Hero Description
          </p>

          <textarea
            className="contentsettings-textarea"
            value={banner.description}
            onChange={(e) =>
              handleBannerChange(
                bannerIndex,
                "description",
                e.target.value
              )
            }
          />

          {/* BANNER IMAGE */}
          <p className="contentsettings-section-title">
            Banner Image
          </p>

          <label className="contentsettings-upload-box">
            {banner.preview ? (
              <img
                src={banner.preview}
                alt=""
              />
            ) : (
              <div className="upload-content">
                Upload Banner
              </div>
            )}

            <input
              type="file"
              hidden
              accept="image/*"
              onChange={(e) =>
                handleBannerImage(
                  bannerIndex,
                  e.target.files[0]
                )
              }
            />
          </label>

          {/* CARD */}
          <p className="contentsettings-section-title">
            Hero Card
          </p>

          <div className="contentsettings-card-block">
            <input
              className="contentsettings-input"
              placeholder="Card title"
              value={banner.card.title}
              onChange={(e) =>
                handleCardChange(
                  bannerIndex,
                  "title",
                  e.target.value
                )
              }
            />

            <textarea
              className="contentsettings-textarea"
              placeholder="Card description"
              value={banner.card.description}
              onChange={(e) =>
                handleCardChange(
                  bannerIndex,
                  "description",
                  e.target.value
                )
              }
            />

            <label className="contentsettings-upload-box">
              {banner.card.preview ? (
                <img
                  src={banner.card.preview}
                  alt=""
                />
              ) : (
                <div className="upload-content">
                  Upload Card Image
                </div>
              )}

              <input
                type="file"
                hidden
                accept="image/*"
                onChange={(e) =>
                  handleCardImage(
                    bannerIndex,
                    e.target.files[0]
                  )
                }
              />
            </label>
          </div>
        </div>
      ))}

      {/* SUCCESS */}
      {showPopup && (
        <div className="contentsettings-overlay">
          <div className="contentsettings-modal">
            <h3>Saved Successfully</h3>

            <p>
              Hero banners updated.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContentSettings;